import React from 'react';
import { ArrowDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col justify-center items-center px-4 py-20 overflow-hidden" data-id="element-62">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-63"></div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-64">
        <div className="flex flex-col space-y-8 text-center lg:text-left" data-id="element-65">
          <div className="space-y-4" data-id="element-66">
            <p className="text-amber-500 tracking-[0.2em] text-sm font-semibold uppercase" data-id="element-67">
              El fin del sufrimiento opcional
            </p>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-zinc-100 leading-tight" data-id="element-68">
              PROTOCOLO DE <br data-id="element-69" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-amber-400 to-amber-600" data-id="element-70">
                CIERRE DE CICLOS
              </span>
            </h1>
          </div>

          <p className="text-xl md:text-2xl text-zinc-400 font-light leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-71">
            Cómo perdonar a quien nunca te pidió perdón{' '}
            <span className="italic text-zinc-300" data-id="element-72">(y no lo hará).</span>
          </p>

          <div className="pt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-6" data-id="element-73">
            <a href="https://www.protocoloperdon.com/cart/44264875327581:1" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-amber-600 hover:bg-amber-500 text-zinc-950 font-bold tracking-wide transition-all duration-300 shadow-[0_0_30px_rgba(217,119,6,0.3)] hover:shadow-[0_0_40px_rgba(217,119,6,0.5)]" data-id="element-74">
              RECLAMAR MI SOBERANÍA
            </a>
            <span className="text-zinc-500 text-sm flex items-center gap-2" data-id="element-75">
              <ArrowDown className="w-4 h-4 animate-bounce" data-id="element-76" />
              Descubre cómo funciona
            </span>
          </div>
        </div>

        <div className="relative flex justify-center items-center perspective-1000" data-id="element-77">
          <div className="relative w-full max-w-md aspect-[4/5] transform lg:rotate-y-[-10deg] transition-transform duration-700 hover:rotate-y-0" data-id="element-78">
            <div className="absolute inset-0 bg-gradient-to-tr from-amber-500/20 to-transparent rounded-lg blur-2xl transform translate-y-8 translate-x-8" data-id="element-79"></div>
            <img src="https://cdn.magicpatterns.com/uploads/xm8bNSfsXCzE4UcXX6QsrQ/imagen_libro.png" alt="Protocolo de Cierre de Ciclos" className="relative z-10 w-full h-full object-contain drop-shadow-2xl" data-id="element-80" />
          </div>
        </div>
      </div>
    </section>;
}